import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
 DestroyRef,
 Inject,
 Injectable,
 OnDestroy,
 PLATFORM_ID,
 WritableSignal,
 inject,
 makeStateKey,
 signal,
 effect,
 computed,
} from '@angular/core';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TransferState } from '@angular/platform-browser';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router,NavigationStart } from '@angular/router';
import { SearchResultHotelsCard } from '@core/models/DTOs/hotel.dto';
import { FilterModel } from '@core/models/domains/filters.model';
import { WebEngageRepository } from '@core/services/repositories/webEngage.repository';
import { SearchPayload, SearchPayloadEcolodge, SearchResponse } from '@models/hotel';
import { PLPRepository } from '@repos/plp.repository';
import { AutocompleteService } from '@shared/services/autocomplete.service';
import { DatepickerService } from '@shared/services/datepicker.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { filter, map, tap } from 'rxjs';
import { AuthService } from '@core/services/authentication/auth.service';
import { HotelCardSkeletonComponent } from '../../home/skeletons/hotel-card-skeleton/hotel-card-skeleton.component';
import { WINDOW } from '../../../app.module';

@Injectable({
 providedIn: 'root',
})
export class SearchResultUiService {
 isPlatformBrowser!: boolean;
 logOutTrigger = false;
 ecolodgeTypeName = signal('');
 ecolodgeHostId = signal('');
 isCountryPage = signal(false);
  IS_MAP_ROUTE_KEY = makeStateKey<boolean>('is_map_route');

  isInMapPage = false;
  accommodationSSR = '';
 
  constructor(@Inject(PLATFORM_ID) private platformId: Object, 
  @Inject(WINDOW) private window: Window) {

  effect(() => {
   this.logOutTrigger = this.authService.logOutTriggered();
   if (this.logOutTrigger) {
    this.resetPlpResults();
   }
  });
 }
 searchRepo = inject(PLPRepository);
 webEngageRepo = inject(WebEngageRepository);
 datePickerService = inject(DatepickerService);
 autoCompleteService = inject(AutocompleteService);
 searchBoxService = inject(SearchBoxService);
 transferState = inject(TransferState);
 destroyRef = inject(DestroyRef);
 route = inject(ActivatedRoute);
 router = inject(Router);
 authService = inject(AuthService);

 searchResult = signal({} as SearchResponse);
 hotelsList: WritableSignal<SearchResultHotelsCard[]> = signal([] as SearchResultHotelsCard[]);
 // hotelsLoading: WritableSignal<boolean> = signal(true);
 nextPageLoading: WritableSignal<boolean> = signal(false);
 prevPageLoading: WritableSignal<boolean> = signal(true);
 activeFilters: WritableSignal<FilterModel[]> = signal([] as FilterModel[]);
 isHotel: string = 'false';
 pageIndex = 0;
 pageSize = -1
 fetchedPages: Array<number> = [];
 lastUsedPayload: SearchPayload = {} as SearchPayload;
 cityName = '';
 cityId = '';
 persianCityName = '';
 isFilterSet = signal(0);
 shabIndex = 0;
 HashKey = signal('');
 recentSearches = signal<any[]>([]);
 isNextPage = true;
 infiniteScrollLimit = 3
 showPagination = signal(false);
 accommodation = computed(() => this.searchBoxService.accommodation());
 

 getHotels(queryParams: any = {}, dynamicsearchfilter: string, accomodation: string) {
  this.pageSize = accomodation == 'ecolodge' ? 24 : 10
  // Recent Searches Of AutoComplete
  this.handleRecentSearches(queryParams);

  let newPayload: SearchPayloadEcolodge | SearchPayload;

  if (Object.keys(queryParams).length > 1)
   newPayload = this.mapQueryParamsToPayloadValues(queryParams, accomodation);
  else newPayload = this.generatePayload(queryParams);
  
  this.handleFetchedPages(
   queryParams.page ? Number(queryParams.page) - 1 : 0,
   newPayload,
   queryParams,
   dynamicsearchfilter,
   accomodation
  );
 }

 handleFetchedPages(
  pageIndexToFetch: number,
  newPayload: SearchPayload,
  queryParams: any,
  dynamicsearchfilter: string,
  accomodation: string
 ) {
  
  

  if (this.searchBoxService.accommodation() == 'ecolodge') {
    pageIndexToFetch = this.pageIndex
    
    if (pageIndexToFetch == 0) {
      this.showPagination.set(false)
    }
    
    if (pageIndexToFetch === this.infiniteScrollLimit) {
      this.showPagination.set(true)
    }
  }
  
  let index = this.fetchedPages.findIndex((n) => n > pageIndexToFetch);
  let alreadyFetched = -1 !== this.fetchedPages.findIndex((n) => n === pageIndexToFetch);

  const searchResultKey = makeStateKey<SearchResponse>('searchResult');


  if (queryParams.page && accomodation == 'ecolodge') {
    this.showPagination.set(true)
  }

  if (
   this.transferState.get(searchResultKey) &&
   Object.keys(this.transferState.get(searchResultKey)).length
  ) {
      
      if (index === -1) this.fetchedPages.push(+pageIndexToFetch);
      else this.fetchedPages.splice(index, 0, +pageIndexToFetch);
    

   this.getDataFromServerState(
    pageIndexToFetch,
    newPayload,
    this.transferState.get(searchResultKey)
   );

   return;
   // || (this.fetchedPages.length === 1 && this.fetchedPages[0] == 0)
  } else if (!alreadyFetched || !this.fetchedPages.length) {
    
  //  if (newPayload['isFirstRequest'] && accomodation == 'ecolodge') {
  //   newPayload['PageIndex'] = '0';
  //  }
   if (!this.nextPageLoading() && !this.prevPageLoading()) this.prevPageLoading.set(true);
   this.searchRepo
     .getHotels(newPayload, dynamicsearchfilter, accomodation)
    .pipe(
     map((res) => {
      return {
       ...res,
       Cards: res.Cards.map((cardData) => ({
        ...cardData,
        Labels: {
         ...cardData.Labels,
         Tags: cardData.Labels?.Tags?.filter((eachTag) => eachTag?.Code !== 45), //preventing to show IHO+ tag in template
        },
       })),
      } as SearchResponse;
     }),
     tap((res) => {
      if (!this.pageIndex) this.sendWebEngageFilterEvent(newPayload, queryParams);

      if (index === -1) this.fetchedPages.push(pageIndexToFetch);
      else this.fetchedPages.splice(index, 0, pageIndexToFetch);
     }),
     takeUntilDestroyed(this.destroyRef)
    )
    .subscribe((response: SearchResponse) => {
     this.HashKey.set(response.HashKey);
     this.shabIndex = response.ShabIndex;
     this.setSignalsValues(response);

     this.setSearchDataOnInit(
      response.Search?.Id,
      response.Search.Type as any,
      response.Search.SearchBox,
      response.Search.StartDate,
      response.Search.EndDate,
      response.Search.Link,
      response.Search?.State
     );

     if (isPlatformServer(this.platformId)) {
      this.transferState.set(searchResultKey, response);
      this.transferState.set('ssrInit', false);
     }
     this.lastUsedPayload.isFirstRequest = false
    });
  }
 }

 setSearchDataOnInit(
  id: number,
  type: 1 | 2 | 3 | 4 | 5,
  name: string,
  startDate: string,
  endDate: string,
  link: string,
  state: string
 ) {
  this.searchBoxService.residentId = id;
  this.searchBoxService.residentType = type;
  this.searchBoxService.residentName = name;
  this.searchBoxService.dateRange = [startDate, endDate];
  this.datePickerService.setStartDate(startDate);
  this.datePickerService.setEndDate(endDate);
  this.autoCompleteService.setSelectedItem({ id, type, name, link, state });
 }

 mapQueryParamsToPayloadValues(queryParams: any, accomodation: string) {
  let newPayload: SearchPayload = {} as SearchPayload;
  let filterUsed = false; //we use it for resetting pageIndex to 0

  const filters = ['minPrice', 'maxPrice', 'labels', 'types', 'grades', 'reviews'];
  const filtersEcologe = [
   'minPrice',
   'maxPrice',
   'labelsAccomodate',
   'hotelStyles',
   'facilities',
   'hotelTypes',
   'accomodationType',
   'hostId',
   'parentId',
  ];
  if (accomodation == 'ecolodge') {
   filtersEcologe.forEach((eachKey: string) => {
    if (queryParams.hasOwnProperty(eachKey))
     (newPayload as any)[eachKey] = String(queryParams[eachKey]);
   });
  } else {
   filters.forEach((eachKey: string) => {
    if (queryParams.hasOwnProperty(eachKey))
     (newPayload as any)[eachKey] = String(queryParams[eachKey]);
   });
  }

  if (queryParams?.page) {
   newPayload['PageIndex'] = String(+queryParams.page - 1);
   this.isNextPage = +queryParams.page > this.pageIndex;
   this.pageIndex = +queryParams.page - 1;
  }
  //  queryParams.hid
  this.isHotel = queryParams.ishotel == 'true' ? queryParams.houseId : '0';
  newPayload = this.generatePayload({
   CityName: queryParams.CityName,
   CountryName: queryParams.CountryName,
   HotelId: queryParams.hid,
   StateId: queryParams.state,
    CityId: queryParams.cityId,
   RegionId: queryParams.region,
   SearchQuery: queryParams.search_box,
   StartDate: queryParams.date,
   EndDate: queryParams.endDate,
   DistrictId: queryParams.dist,
   ReferUrl: queryParams.refer,
   Sort: queryParams.sort,
   type: queryParams.type,
   typeName: queryParams?.typeName,
   ...newPayload,
  });
  if (queryParams.CityName === 'search') delete newPayload.CityName;
  else this.lastUsedPayload.CityName = queryParams.CityName;

  return newPayload;
 }

 getDataFromServerState(pageIndex: number, payload: SearchPayload, response: SearchResponse) {
  
  this.lastUsedPayload = payload;
  this.pageIndex = pageIndex;

  this.HashKey.set(response.HashKey);

  this.setSignalsValues(response);

  this.setSearchDataOnInit(
   response.Search.Id,
   response.Search.Type as any,
   response.Search.SearchBox,
   response.Search.StartDate,
   response.Search.EndDate,
   response.Search.Link,
   response.Search.State
  );

  this.transferState.set('searchResult', undefined);
 }

 setSignalsValues(searchResponseFromRouteData?: SearchResponse) {
  // this.hotelsLoading.set(true)
  if (searchResponseFromRouteData) {
   this.nextPageLoading.set(false);
   this.prevPageLoading.set(false);

   if (this.isNextPage) {
    this.hotelsList.set([...this.hotelsList(), ...searchResponseFromRouteData.Cards]);
   } else {
    this.hotelsList.set([...searchResponseFromRouteData.Cards, ...this.hotelsList()]);
   }

   this.searchResult.set(searchResponseFromRouteData);
   this.persianCityName = searchResponseFromRouteData?.Search?.SearchBox;
  }
 }

 generatePayload(extension: Partial<SearchPayload> = {}): SearchPayload {
  let referrer = 'iranlist';

  if (extension.CityName && extension.CityName !== 'search') this.cityName = extension.CityName;
  if (typeof this.pageIndex === 'undefined') this.pageIndex = 0;

  if (extension?.['ReferUrl']) referrer = extension['ReferUrl'];

  if (!Object.keys(this.lastUsedPayload).length) {
   this.lastUsedPayload.isFirstRequest = true;
  } else this.lastUsedPayload.isFirstRequest = false;

  this.lastUsedPayload = {
   HotelId: this.isHotel,
   StateId: '0',
   CityId: '0',
   RegionId: '0',
   DistrictId: '0',
   ReferUrl: referrer,
   NoRoom: '2',
   Nights: '2',
   Kind: 'double',
   Adult: '2',
   Child: '0',
   Room: '1',
   Sort: '',
   ShabIndex: this.pageIndex != 0 ? this.shabIndex : 0,
   SearchQuery: this.searchBoxService.residentName,
   type: this.searchBoxService.residentType.toString(),
   StartDate: referrer !== 'iranlist' ? this.searchBoxService.getStartAndEndDate()[0] : '',
   EndDate: referrer !== 'iranlist' ? this.searchBoxService.getStartAndEndDate()[1] : '',
   PageIndex:
    extension?.PageIndex !== undefined ? String(+extension.PageIndex - 1) : String(this.pageIndex),
   PageSize: String(this.pageSize),
   isFirstRequest: this.lastUsedPayload.isFirstRequest,
   ...Object.fromEntries(Object.entries(extension).filter(([_, value]) => value)),
  };

  return this.lastUsedPayload;
 }

 handleRecentSearches(queryParams: any) {
  if (this.isPlatformBrowser) {
   if (localStorage.getItem('RecentSearches')!)
    this.recentSearches.set(
     JSON.parse(localStorage.getItem('RecentSearches')!).filter((savedSearch: any) => {
      if (!['', undefined, null].includes(savedSearch.link)) return savedSearch;
     })
    );

   const lastSelectedItem = this.autoCompleteService._recentSelectedItem();

   if (lastSelectedItem.name)
    this.recentSearches.mutate((searches) => {
     if (
      queryParams.date &&
      queryParams.endDate &&
      !searches.find((search) => {
       return (
        search.date == queryParams.date &&
        search.endDate == queryParams.endDate &&
        search.name == lastSelectedItem.name
       );
      })
     )
      if (!this.searchBoxService.isShabAdsCode()) {
       searches.unshift({
        ...lastSelectedItem,
        date: queryParams.date,
        endDate: queryParams.endDate,
        ecolodge: this.searchBoxService.accommodation() == 'ecolodge' ? 'ecolodge' : 'hotel',
       });
      }

     if (this.recentSearches().length > 3) searches.pop();
    });

   localStorage.setItem('RecentSearches', JSON.stringify(this.recentSearches()));

   this.autoCompleteService.setRecent(JSON.parse(localStorage.getItem('RecentSearches')!));
   this.autoCompleteService.adCode.set(false);
   this.searchBoxService.isShabAdsCode.set(false);
  }
 }

 sendWebEngageFilterEvent(queryParams: any, newPayload: Partial<SearchPayload>) {
  if (
   newPayload &&
   Object.keys(queryParams).length > 1 &&
   (queryParams?.pageIndex, queryParams.pageIndex === 0) &&
   (queryParams.minPrice ||
    queryParams.maxPrice ||
    queryParams.grades ||
    queryParams.reviews ||
    queryParams.types ||
    queryParams.labels)
  ) {
   //  اینجا کاملا مطمئنیم که توی فیلتریم دیگه:)))))))
   const webEngagePayload = {
    Sort: newPayload.Sort,
    MinPrice: newPayload.minPrice ?? '',
    MaxPrice: newPayload.maxPrice ?? '',
    Grades: newPayload.grades ? newPayload.grades.split(',') : [],
    Reviews: newPayload.reviews ? newPayload.reviews.split(',') : [],
    Types: newPayload.types ? newPayload.types.split(',') : [],
    Labels: newPayload.labels ? newPayload.labels.split(',') : [],
   };

   this.webEngageRepo
    .filter(webEngagePayload)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(() => {});
  }
 }

 resetPlpResults() {
  this.fetchedPages = [];
  this.pageIndex = 0;
  this.hotelsList.set([]);
  this.prevPageLoading.set(true);
 }
}
